//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles

// @ADD Component types
interface IJournalsScreenProps {}

const JournalsScreen: React.FC<IJournalsScreenProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="container">
        <BannerTextPrimaryCommon text={"Boletines"}/>
        <AllThingsModule type='journal' />
      </div>
    </PublicAppLayout>
  )
}

export default JournalsScreen
